import { 
    AmbientLight, 
    Group, 
    DirectionalLight,
    UnsignedByteType,
    PMREMGenerator
} from "three"

import { RGBELoader } from 'Application/Material/HDR/RGBELoader'

/*****************************************************************
 * Light Provider
 * ***************************************************************/

let setup = new Group(),
lightMarker = new Group()

const 
    mouthLight = new AmbientLight(0xffffff, 0.5, 100, 200),
    frontLight = new DirectionalLight(0xffffff, 0, 250),
    keyLight = new DirectionalLight(0xffffff, 3, 500, 180, 0, 20),
    fillLight = new DirectionalLight(0xffffff, 3, 500, 180, 0, 20),
    backLightHigh = new DirectionalLight(0xffffff, 0, 200, 180, 0, 20),
    backLightLow = new DirectionalLight(0xffffff, 1, 500, 180, 0, 20),
    lightPosition = ( light, x, y, z ) => light.position.set( x, y, z),
    lightsSetup = () => {
        setup.name = 'lightsSetup'
        setup.add( mouthLight, keyLight, fillLight, backLightHigh, backLightLow, frontLight )
        lightPosition( mouthLight, 0, 0, 20)
        lightPosition( keyLight, -100, 0, 50)
        lightPosition( fillLight, 100, 0, 0)
        lightPosition( backLightHigh, 0, 50, 50)
        lightPosition( backLightLow, 0, 20, -30)
        lightPosition( frontLight, 0, -100, -20)
        return setup
    }
/**
 * Provide 3D light setup
 * @returns Group
 */
export const LightingSetup = center => {
    let lights = lightsSetup()
    if( center ){
        lights.children.forEach( light => {
            if( light.type !== "AmbientLight" ){
                light.lookAt( center )
            }
        })
    }
    return lights
}


export const setLighting = ( scene = null, renderer = null ) => new Promise( (resolve, reject) => {

    let pmremGenerator = null;

    new RGBELoader()
            .setDataType( UnsignedByteType )
            .load( process.env.REACT_APP_U1_VIEWERSVC_APP+'img/std2.hdr' , texture => {

            pmremGenerator = new PMREMGenerator( renderer )
            pmremGenerator.compileEquirectangularShader()

            let envMap = pmremGenerator.fromEquirectangular( texture ).texture
            scene.environment = envMap

            texture.dispose()
            pmremGenerator.dispose()
            pmremGenerator = null;
        }, 
        undefined,
        (error) => {
            console.error('Failed to load HDR:', error);
            if (pmremGenerator) {
                pmremGenerator.dispose();
                pmremGenerator = null;
            }
            resolve(lightMarker);
        });

        renderer.toneMappingExposure = 1

        resolve(lightMarker)
    }
)
